export default __webpack_public_path__ + "static/media/piper-chair.d5ee9797.jpg";